// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_5D3TwVaT","video":"_5D1HDdnT","overlay":"_5D2TE9Z9","icon":"_5D3gSSwq"};